<template lang="pug">
div
  .company-new-form.justify-center(v-if="dataHasLoaded")
    handle-form(
      @close-form="closeForm",
      :parentData="{ method: 'create', item: 'company', form_title: form_data.form_header.title.add, title_icon_path: title_icon_path, path: path['company'], grid: 'companies', data: form_data, formStepper }"
    )
</template>

<script>
import handleForm from "../../shared/forms/Form";

export default {
  components: {
    handleForm,
  },

  props: {
    parentData: {
      type: Object,
      default: () => {},
    },
  },
  data: function () {
    return {
      path: this.$store.state.paths,
      title_icon_path: "add_header.svg",
      callback_params: this.parentData.callback_params,
      form_data: [],
      dataHasLoaded: false,
      formStepper: this.parentData.formStepper || [],
      facilityId: this.parentData.facilityId || null,
    };
  },

  created() {},

  mounted() {
    this.loadFormData();
  },

  methods: {
    closeForm(data) {
      this.$emit("close-form", data);
    },

    loadFormData() {
      let form_data_path = this.path["company"] + "/form_data";

      this.$backend
        .index(form_data_path, { params: {} })
        .then(({ data }) => {
          if (this.facilityId) {
            const newData = data.fields.map(el => {
              if (el.name === "facility_id") {
                const newEl = el;
                newEl.value = this.facilityId;
                return newEl;
              } else {
                return el;
              }
            });

            data.fields = newData;

            this.form_data = data;
          } else {
            this.form_data = data;
          }
        })
        .catch(error => {
          console.log(error);
          if (error.response) {
            this.reLogin(error.response.status);
          }
        })
        .finally(() => {
          this.dataHasLoaded = true;
        });
    },
  },
};
</script>

<style lang="scss"></style>
